import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import {
	HoverInfo,
	Info,
	SeparatorLine,
	SubTitle,
	TopInfoWrapper,
	Wrapper,
} from './YourScore.styles';
import Icon from '@/common/components/Icon';
import MainScore from './components/mainScore/MainScore';
import InfoPopup from './components/infoPopup/InfoPopup';
import { useYourScore } from './hooks/useYourScore';
import { TARGET_THRESHOLD } from './constants/thresholds';

const YourScore = () => {
	const { translation } = useTranslationContext();
	const { dailyContactsHistory, hours, isLoading } = useYourScore();

	return (
		<Wrapper>
			<TopInfoWrapper>
				<SubTitle>{translation.your_score}</SubTitle>
				<HoverInfo>
					<Icon
						name='info'
						style={{
							border: '1px solid gray',
							borderRadius: '50%',
							padding: '3px',
							width: '16px',
							height: '16px',
						}}
					/>
					<InfoPopup
						title={translation.your_score_info_title}
						firstParagraph={translation.your_score_info_paragraph_one}
						secondParagraph={translation.your_score_info_paragraph_two}
						thirdParagraph={translation.your_score_info_paragraph_three}
					/>
				</HoverInfo>
			</TopInfoWrapper>
			<MainScore
				dailyContactsHistory={dailyContactsHistory}
				hours={hours}
				isLoading={isLoading}
			/>
			<SeparatorLine />
			<Info>
				{translation.target}: {TARGET_THRESHOLD} {translation.confirmations_per_hour}
			</Info>
		</Wrapper>
	);
};

export default YourScore;
